type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

/** For use in nav/sidebar: inherits text color and 20px size */
export function IconRawMaterialsForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconRawMaterials
      className={className}
      color="currentColor"
      size={20}
    />
  );
}

export function IconRawMaterials({
  color = "#3D3935",
  size = 26,
  className,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M11.9918 1.73098C10.9127 1.22899 9.66708 1.229 8.58803 1.73099L2.60387 4.5149C1.18097 5.17685 0.270996 6.60381 0.270996 8.17315V14.6373C0.270996 16.2186 1.19482 17.6542 2.63407 18.3094L8.61823 21.0336C9.68024 21.517 10.8996 21.517 11.9616 21.0336L12.8048 20.6497C13.0742 20.5271 13.2556 20.2677 13.2783 19.9727C13.3078 19.5896 13.4255 19.1791 13.6149 18.7354C13.7019 18.5316 13.7019 18.3011 13.6149 18.0973C13.2081 17.1445 13.1298 16.354 13.557 15.6152L14.2305 14.4503C14.6579 13.7109 15.3846 13.3817 16.4167 13.2555C16.6356 13.2287 16.8342 13.114 16.967 12.9379C17.5907 12.1099 18.2389 11.6456 19.0974 11.6456H19.4963C19.945 11.6456 20.3088 11.2818 20.3088 10.8331V8.17315C20.3088 6.60381 19.3988 5.17685 17.9759 4.5149L11.9918 1.73098Z"
        fill={color}
      />
      <path
        d="M17.9759 4.5149C19.1074 5.0413 19.9146 6.05148 20.1977 7.23233L10.9679 11.3355L10.9679 21.3388C10.5198 21.4152 10.0618 21.4153 9.61369 21.3391L9.6137 11.3363L0.382324 7.23098C0.665738 6.05071 1.47271 5.0411 2.60381 4.5149L4.491 3.63696L14.3696 8.34105L15.9986 7.61689L6.08422 2.89577L8.58797 1.73099C9.66702 1.229 10.9127 1.22899 11.9917 1.73098L17.9759 4.5149Z"
        fill={color}
      />
      <path
        d="M5.01026 15.3436C5.15649 14.9994 5.55403 14.8389 5.8982 14.9852L7.8482 15.8136C8.19236 15.9599 8.35283 16.3574 8.2066 16.7016C8.06038 17.0457 7.66284 17.2062 7.31867 17.06L5.36867 16.2315C5.0245 16.0853 4.86404 15.6877 5.01026 15.3436Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9651 19.0073C14.3808 19.3453 14.181 20.0933 14.518 20.6781L15.1894 21.843C15.5266 22.4281 16.2738 22.6289 16.8583 22.2908C17.3109 22.0291 17.878 22.3558 17.878 22.8812C17.878 23.5563 18.4245 24.1045 19.0996 24.1045H20.4423C21.1174 24.1045 21.6639 23.5563 21.6639 22.8812C21.6639 22.3557 22.231 22.029 22.6835 22.2908C23.2681 22.6288 24.0153 22.428 24.3525 21.8429L25.0239 20.678C25.3609 20.0932 25.1611 19.3452 24.5769 19.0073C24.1234 18.745 24.1234 18.0889 24.5769 17.8266C25.1611 17.4886 25.3609 16.7407 25.0239 16.1559L24.3525 14.9909C24.0153 14.4058 23.2681 14.205 22.6835 14.5431C22.231 14.8048 21.6639 14.4782 21.6639 13.9527C21.6639 13.2776 21.1174 12.7295 20.4423 12.7295H19.0995C18.4244 12.7295 17.878 13.2776 17.878 13.9527C17.878 14.4781 17.3109 14.8048 16.8584 14.5431C16.2738 14.205 15.5266 14.4058 15.1894 14.9909L14.518 16.1558C14.181 16.7406 14.3808 17.4886 14.9651 17.8265C15.4186 18.0888 15.4186 18.745 14.9651 19.0073ZM21.3959 18.417C21.3959 19.3145 20.6684 20.042 19.7709 20.042C18.8734 20.042 18.1459 19.3145 18.1459 18.417C18.1459 17.5195 18.8734 16.792 19.7709 16.792C20.6684 16.792 21.3959 17.5195 21.3959 18.417Z"
        fill={color}
      />
    </svg>
  );
}
